import getNative from './_getNative.js';

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

export default nativeCreate;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_nativeCreate.js
// module id = 120
// module chunks = 7